/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/require-default-props */
import React, { useEffect, useRef } from 'react';
import { Col, Empty, Row } from 'antd';
import classNames from 'classnames';
import ContactCardSkeleton from 'modules/Common/Skeleton/ContactCardSkeleton';
import InfiniteScroll from 'react-infinite-scroll-component';
import { IContactItem } from 'modules/Audience/interface';
import ContactCardGlobal from 'modules/Common/Components/ContactCardGlobal';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

type Props = {
  data: IContactItem[];
  loading: boolean;
  listView: boolean;
  isListActive?: boolean;
  loadMore: () => void;
  handleSelectContacts: (contact: IContactItem) => void;
  selectedCount: number;
  selectDisable?: boolean;
  isSearch: boolean;
  selectedContactsIds: number[];
  refreshLoading: boolean;
  page?: boolean;
  addToListMode?: boolean;
  scrollPercentage?: number;
  setScrollPercentage?: (percentage: number) => void;
};

const ContactsGrid = (props: Props) => {
  const {
    data,
    loading,
    listView,
    loadMore,
    handleSelectContacts,
    selectedCount,
    selectDisable,
    isSearch,
    selectedContactsIds,
    isListActive,
    refreshLoading,
    addToListMode,
    scrollPercentage,
    setScrollPercentage,
    page,
  } = props;

  const selectedContactFilter = useSelector((state: RootState) => state.contactsFilters.globalContactsFilters.appliedFilters);
  const scrollContainerRef = useRef(null);
  const filterApplied = selectedContactFilter.designation.length > 0 || selectedContactFilter.status.length > 0
    || selectedContactFilter.organization.length > 0 || selectedContactFilter.personalityType.length > 0;

  const handleScroll = (event: React.UIEvent<HTMLElement>) => {
    if (setScrollPercentage) {
      const target = event.target as HTMLElement;
      const scrollTop = target?.scrollTop;
      const scrollHeight = target?.scrollHeight;
      const clientHeight = target?.clientHeight;
      const percentage = (scrollTop / (scrollHeight - clientHeight));
      setScrollPercentage(percentage);
    }
  };

  useEffect(() => {
    if (scrollContainerRef.current && scrollPercentage) {
      // eslint-disable-next-line
      const scrollableNode = scrollContainerRef?.current?._infScroll;
      const contentHeight = scrollableNode.scrollHeight - scrollableNode.clientHeight;
      const targetScrollPosition = scrollPercentage * contentHeight;
      scrollableNode.scrollTop = targetScrollPosition;
    }
  }, []);

  return (
    <InfiniteScroll
      dataLength={data.length + 1}
      next={loadMore}
      hasMore
      loader={false}
      scrollableTarget="scrollableDiv"
      onScroll={handleScroll}
      ref={scrollContainerRef}
      className={classNames('aud-Infinite-scroll', { loadingFlag: loading })}
      // scrollableTarget="contacts-list"
      height="auto"
    >
      <Row gutter={[20, 20]} className={classNames('audience-module-row contacts-row grid-view', { emptyRowContactsGrid: data.length === 0 && !loading })}>
        {data.map((contact, index) => (
          <Col span={6} className={classNames('audience-module-col', { gridCol: true })}>
            {refreshLoading || (loading && data.length === 0) ? (
              <ContactCardSkeleton listView={false} />
            ) : (
              <ContactCardGlobal
                contact={contact}
                listView={listView}
                isSelected={selectedContactsIds.includes(contact.contactId)}
                handleSelectContacts={handleSelectContacts}
                selectedCount={selectedCount}
                index={index}
                selectDisable={selectDisable || (contact?.isListContact && page !== undefined) || isListActive}
                addToListMode={addToListMode}
              />
            )}
          </Col>
        ))}
        {refreshLoading || (loading && data.length >= 0) ? (
          Array.from({ length: 4 }).map((_, index) => (
            <Col span={6} className={classNames('audience-module-col', { gridCol: true })}>
              <ContactCardSkeleton key={`contact-card-loader-${index + 1}`} listView={false} />
            </Col>
          ))
        ) : null}
        {data.length === 0 && !loading ? (
          <div className="no-data-found">
            <Empty description={`${isSearch || filterApplied ? 'No contact(s) found against your search' : 'Your contact(s) will show up here once you will import a list or create a new contact.'}`} image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </div>
        ) : null}
      </Row>
    </InfiniteScroll>
  );
};

ContactsGrid.defaultProps = {
  selectDisable: false,
  isListActive: false,
  addToListMode: false,
};

export default ContactsGrid;
